/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pct_decrease_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate the percentage decrease between two numbers. Enter the original and new value to see the percent drop instantly, with the formula and worked examples.`)
};

const es_pct_decrease_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula la disminución porcentual entre dos números. Introduce el valor original y el nuevo para ver la caída porcentual al instante, con la fórmula y ejemplos resueltos.`)
};

const de_pct_decrease_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechne den prozentualen Rückgang zwischen zwei Zahlen. Gib Ausgangswert und neuen Wert ein und sieh sofort den Rückgang in Prozent, mit Formel und Beispielen.`)
};

const nl_pct_decrease_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de percentagedaling tussen twee getallen. Vul de oorspronkelijke en nieuwe waarde in voor direct de daling in procenten, met formule en voorbeelden.`)
};

const fr_pct_decrease_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez la diminution en pourcentage entre deux nombres. Entrez la valeur d'origine et la nouvelle valeur pour voir la baisse instantanément, avec la formule et des exemples détaillés.`)
};

const it_pct_decrease_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola il calo percentuale tra due numeri. Inserisci il valore originale e quello nuovo per vedere subito la diminuzione, con formula ed esempi svolti.`)
};

const pt_br2_pct_decrease_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a diminuição percentual entre dois números. Insira o valor original e o novo valor para ver a queda percentual na hora, com a fórmula e exemplos resolvidos.`)
};

const pt_pct_decrease_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a diminuição percentual entre dois números. Insira o valor original e o novo valor para ver a queda instantaneamente, com fórmula e exemplos resolvidos.`)
};

const ja_pct_decrease_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2つの数値の間のパーセント減少を計算。元の値と新しい値を入力すると、計算式と計算例つきでパーセントの下落がすぐに分かります。`)
};

const zh_pct_decrease_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算两个数字之间的百分比减少。输入原始值和新值，即时查看降幅百分比，并附有公式和详解示例。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pct_decrease_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pct_decrease_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pct_decrease_meta_description", locale)
	if (locale === "en") return en_pct_decrease_meta_description(inputs)
	if (locale === "es") return es_pct_decrease_meta_description(inputs)
	if (locale === "de") return de_pct_decrease_meta_description(inputs)
	if (locale === "nl") return nl_pct_decrease_meta_description(inputs)
	if (locale === "fr") return fr_pct_decrease_meta_description(inputs)
	if (locale === "it") return it_pct_decrease_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_pct_decrease_meta_description(inputs)
	if (locale === "pt") return pt_pct_decrease_meta_description(inputs)
	if (locale === "ja") return ja_pct_decrease_meta_description(inputs)
	return zh_pct_decrease_meta_description(inputs)
};